<template>
<div class="service container-fuild" style="padding:20px 180px; min-width:1200px;background-color: #fff;">
    <!-- 信用报告 -->
    <div class="service-block1">
      <div class="service-block1-text">
        <div class="service-block1-title">企业信用报告</div>
        <P class="service-block1-content">基于企业工商、经营、财务、司法、行政监管等多维度信息进行收集、分类、 分析揭示相关企业的基本信息、经营实力、发展潜力、信用记录和风险水平，帮 助用户从海量信息中直接提炼与企业信用相关的有效信息，快速、全方位掌握企 业整体信用状况打破政府、企业、金融机构之间的信息不对称问题。</P>
        <div class="service-block1-num">
          <div><span style="color:#FC6943;font-size:24px;font-weight:bold;margin:20px 0;display:inline-block;">{{count.exportEnterpriseCount}}</span>次</div>
          <div>查询次数</div>
        </div>
        <div class="service-block1-num">
          <div><span style="color:#FC6943;font-size:24px;font-weight:bold;margin:20px 0;display:inline-block;">{{count.exportEnterpriseDetailCount}}</span>次</div>
          <div>下载报告</div>
        </div>
      </div>
      <div class="service-block1-img">
        <img style="max-width:300px;width:55%;cursor: pointer;" src="@/assets/img/home/basic.png" alt="加载中" @click="getCreditReport(1)">
        <img style="max-width:250px;width:45%;padding-right:25px;cursor: pointer;" src="@/assets/img/home/detail.png" alt="加载中" @click="getCreditReport(2)">
      </div>
    </div>
    <!-- 应用场景 -->
    <!-- <div class="service-block2">
        <div class="service-block2-title">政策解读<span class="service-block2-title-eng">POLICY INTERPRETATION</span></div>
        <div class="service-block2-picList">
          <img
            src="@/assets/img/home/pic1.png"
            alt="加载中"
          >
          <img
            src="@/assets/img/home/pic2.png"
            alt="加载中"
          >
          <img
            src="@/assets/img/home/pic3.png"
            alt="加载中"
          >
          <img
            src="@/assets/img/home/pic4.png"
            alt="加载中"
          >
        </div>
      </div> -->
    <!-- 公共等级评价 -->
    <!-- <div class="service-block3">
          <div class="service-block3-head">
              <span style="font-size:24px;font-weight:bold;margin:30px 60px 0 0">公共信用等级评价</span>
              <span>申请服务<i class="el-icon-arrow-right el-icon--right" /></span>
          </div>
          <p style="color:#343536;font-size:18px;line-height:30px;text-indent: 2em;margin-top:20px;">企业公共信用评价是采用有效公共信用信息的量化积分方法，对企业履行社会承诺的意愿和表现的评价活动，其由基本信息、失信信息、 增信信息三部分组成，具有科学性、合理性、适用性、操作性和扩展性的基本原则，能够反映中小企业的公共信用状况。
          </p>
          <img src="" alt="">
      </div> -->
</div>
</template>

<script>
import {
  getExportCont,
  getExportDetail,
  getExportBasic
} from "@/api";
import {
  downloadFile
} from "@/utils/index";
export default {
  name: 'service',
  data() {
    return {
      userInfoweb: this.$store.state.system.userInfoweb,
      token: this.$store.state.system.token,
      count: {}
    }
  },

  methods: {
    async getCount() {
      const res = await getExportCont();
      if (res && res.data) {
        this.count = res.data
      }
    },
    getCreditReport(type){
      if(this.token&&this.userInfoweb&&(this.userInfoweb.type==4)){ //是否登录企业端
          if(type==1){
            this.downloadBasic()
          }else if(type==2){
            this.downloadDetail();
          }
      }else{
          this.$confirm('是否登录企业账号？', '', {
            confirmButtonText: '登录',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$router.push({
              name: 'login',
              query: {
                type: 1,
              },
            });
          }).catch(() => {
          });
      }
    },
    //信用报告下载
    downloadBasic() {
      if (!this.$store.state.system.userInfoweb || this.$store.state.system.userInfoweb.type != 4) {
        return this.$baseMessage("请先登录企业账号", "error");
      }
      const loading = this.$loading({
        lock: true,
        text: "拼命导出中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      downloadFile(
        `/credit/enterprise/2001050004/export`,
        "get",
        (this.$store.state.system.userInfoweb.enterpriseName + '信用报告--基础版'),
        loading,
        "导出失败",
        ".pdf", {
          creditCode: ""
        }
      );
    },
    downloadDetail() {

      if (!this.$store.state.system.userInfoweb || this.$store.state.system.userInfoweb.type != 4) {
        return this.$baseMessage("请先登录企业账号", "error");
      }
      const loading = this.$loading({
        lock: true,
        text: "拼命导出中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      downloadFile(
        `/credit/enterprise/2001050004/exportDetail`,
        "get",
        (this.$store.state.system.userInfoweb.enterpriseName + '信用报告--详细版'),
        loading,
        "导出失败",
        ".doc", {
          creditCode: ""
        }
      );
    },

  },
  mounted() {
    this.getCount();

  }
}
</script>

<style scoped>
/* .service {
  padding: 0 15%;
} */

.service-block1 {
  box-shadow: 3px 3px 12px #cecdcd;
  min-height: 300px;
  height: 400px;
  margin-top: 35px;
}

.service-block1-text {
  float: left;
  width: 60%;
  padding: 0 3%;
}

.service-block1-title {
  font-size: 24px;
  margin: 12px 0;
  font-weight: bold;
  margin: 30px 0;
}

.service-block1-content {
  text-indent: 2em;
  font-size: 18px;
  line-height: 30px;
  display: block;
}

.service-block1-num {
  display: inline-block;
  width: 50%;
  padding-left: 15%;
  margin-top: 30px;
}

.service-block1-img {
  display: inline-flex;
  justify-content: center;
  width: 40%;

  margin: 20px 0;
}

.service-block1-img img {
  display: inline-block;
  object-fit: contain;
}

.service-block2-title {
  font-size: 26px;
  font-weight: bold;
  text-align: center;
  margin: 35px 0;
  letter-spacing: 0.3px;
}

.service-block2-title-eng {
  color: #cecdcd;
  margin-left: 20px;
}

.service-block2-picList {
  display: flex;
  justify-content: space-between;
}

.service-block2-picList img {
  width: 23.5%;
}

.service-block3 {
  margin-top: 30px;
}

@media screen and (max-width: 767px) {

  /*TODO-公共*/
  .service .container {
    margin-top: 0px;
  }
}
</style>
